(function() {
    'use strict';

    angular.module('ksef').controller(
        'KSeFInvoiceUnsentModalController', KSeFInvoiceUnsentModalController);

    KSeFInvoiceUnsentModalController.$inject = ['$uibModalInstance', 'dataObj', '$state'];

    function KSeFInvoiceUnsentModalController($uibModalInstance, dataObj, $state) {
        var self = this;

        self.loading = false;
        self.data = dataObj;

        self.goToInvoices = goToInvoices;
        self.modalClose = modalClose;

        function goToInvoices() {
            $uibModalInstance.dismiss('cancel');
            $state.go('layout.invoice.list');
        }

        function modalClose() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
